/* nprogress 顶部进度条插件
* NProgress.start() 开始显示
* NProgress.set(0.3)  进度从 0.3开始
* NProgress.inc(0.3)    进度条以等比增加 0.3
*
* config:
*   minimum: 0 // 最小值
*   template: '<div></div>'  自定义模板
*   showSpinner: true   是否显示 加载中动画
*
*/
import router from '../router'
import store from '../store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getItem, setItem, removeItem } from './auth' // get token from cookie
import getPageTitle from './get-page-title'

// 去除加载图标显示
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/404'] // no redirect whitelist

// 路由进入前
router.beforeEach(async (to, from, next) => {
    // start progress bar
    NProgress.start()

    // 设置页面标题
    document.title = getPageTitle(to.meta.title)

    // 如果是跳入的
    if (to.query.token) {
        setItem('token', to.query.token)
    }

    // 获取token 判断用户是否已登录
    const hasToken = to?.query?.token ? to.query.token : getItem('token')

    // 如果是跳入的 --- 其他项目
    if (to.query.isFromOther) {
        let params = {
            username: '系统用户',
            password: 'test'
        }

        if (hasToken) {
            next('/resources_management')
            NProgress.done()
        } else {
            store.dispatch('user/loginIn', params)
                .then(res => {
                    next('/resources_management')
                    NProgress.done()
                })
                .catch(err => {
                    window.close()
                })
        }
    } else if (to.path === '/projectAnalysis' || to.path === '/projectAnalysis/estimate-price') {
        if (hasToken) {
            // 判断当前用户是否已拉取完user_info信息
            const hasUserId = store.state.user.userInfo.id
            if (hasUserId) {
                store.dispatch('menu/setRoleBtns', to.path)
                next()
            } else {
                // 请求个人信息
                store.dispatch('user/getUserInfo', hasToken).then(res => {
                    next()
                    NProgress.done()
                }).catch(err => {
                    next({path: '/404'})
                    NProgress.done()
                })
            }
            // next()
            // NProgress.done()
        } else {
            // 审计作业里面的  造价分析对接页面
            let params = {
                username: 'sjAdmin',
                password: 'admin123'
                // username: 'zzh',
                // password: 'test'
            }
            store.dispatch('user/loginIn', params)
                .then(res => {
                    next()
                    NProgress.done()
                })
                .catch(err => {
                    window.close()
                })
        }
        // return
    } else {
        if (to.path === '/404') {
            next()
            NProgress.done()
            return
        }
        if (hasToken) {
            if (to.path === '/login') {
                // if is logged in, redirect to the home page
                // next({ path: '/' })
                next()
                NProgress.done()
                // 清除token 
                removeItem('token')
            } else {
                let routeList = store.state.menu.routeList
                // 判断当前用户是否已拉取完user_info信息
                const hasInfo = store.state.user.userInfo.id
                if (hasInfo) {
                    store.dispatch('menu/setRoleBtns', to.path)
                    next()
                } else {
                    // 请求个人信息
                    store.dispatch('user/getUserInfo').then(res => {

                        // 获取菜单
                        store.dispatch('menu/setMenuList', hasToken).then(() => {
                            router.addRoutes(store.state.menu.activeRoutes) // 动态添加可访问路由表
                            store.dispatch('menu/setRoleBtns', to.path)
                            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                        })
                    }).catch(err => {
                        next({ path: '/404' })
                        NProgress.done()
                    })
                }
            }
        } else {
            /* has no token*/
            setTimeout(() => {
                if (whiteList.indexOf(to.path) !== -1) {
                    // in the free login whitelist, go directly
                    next()
                    NProgress.done()
                } else {
                    // other pages that do not have permission to access are redirected to the login page.
                    next({ path: '/404' })
                    NProgress.done()

                    // 可在接口中处理
                    setTimeout(() => {
                        // location.reload()
                        Message.error('token 已失效，请重新登录')
                    }, 500)
                }
            }, 500)

        }
    }
})

router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})